import React from "react";
import {Bar} from "@ant-design/plots";

const BarChart = () => {
  const data = [
    {
      year: "Kho 1",
      value: 38,
    },
    {
      year: "Kho 2",
      value: 52,
    },
    {
      year: "Kho 3",
      value: 61,
    },
    {
      year: "Kho 4",
      value: 145,
    },
    {
      year: "Kho 5",
      value: 48,
    },
  ];
  const config = {
    data,
    xField: "value",
    yField: "year",
    seriesField: "year",
    legend: {
      // position: "top-left",
    },
  };
  return (
    <div className="container">
      <Bar {...config} />
    </div>
  );
};
export default BarChart;
